import React from "react";
import PropTypes from "prop-types";

import "./SignInButton.css";

export default class SignInButton extends React.Component {
  render() {
    return (
      <div
        style={{
          width: "100%",
          padding: "10px 20px"
        }}
      >
        <button className="signInButton" onClick={this.props.onClick}>
          {this.props.text || "SIGN IN"}
        </button>
      </div>
    );
  }
}

SignInButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string
};
